// components/LiteYouTube.tsx

import { useState } from 'react';

interface LiteYouTubeProps {
    videoId: string;
    title?: string;
}

const LiteYouTube = ({ videoId, title = 'YouTube video' }: LiteYouTubeProps) => {
    const [isIframeLoaded, setIsIframeLoaded] = useState(false);
    const thumbnail = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
    const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

    return (
        <div
            style={{
                position: 'relative',
                width: '100%',
                paddingBottom: '56.25%',
                backgroundImage: `url(${thumbnail})`,
                backgroundSize: 'cover',
                cursor: 'pointer',
            }}
            onClick={() => setIsIframeLoaded(true)}
        >
            {!isIframeLoaded && (
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        fontSize: '48px',
                        color: '#fff',
                        background: 'rgba(0, 0, 0, 0.6)',
                        padding: '10px 20px',
                        borderRadius: '50%',
                    }}
                >
                    ▶
                </div>
            )}
            {isIframeLoaded && (
                <iframe
                    src={embedUrl}
                    title={title}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 0,
                    }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            )}
        </div>
    );
};

export default LiteYouTube;
